import React from "react";

import { Button } from "@/components/Button";
import { Flex, IDialogModal, inDialogModal, Text } from "@/eworkitComponents";
import { EDialogType, IDialog } from "@/eworkitComponents";
import { StyledModal } from "@/views/components/Modal";

import { resources } from "./resources";

interface IDialogComponent extends IDialog, IDialogModal {}

class DialogComponent extends React.PureComponent<IDialogComponent> {
  handleApprove = () => {
    const { onApprove, onClose } = this.props;
    if (onApprove) {
      onApprove();
    }
    onClose();
  };

  handleCancel = () => {
    const { onCancel, onClose } = this.props;
    if (onCancel) {
      onCancel();
    }
    onClose();
  };

  render() {
    const { labelApprove, labelCancel, type, text, title, component } = this.props;

    if (title) {
      // eslint-disable-next-line no-console
      console.warn("Dialog not support title prop");
    }

    return (
      <StyledModal>
        <Flex direction="column" innerMargin="md" padding={["xl"]}>
          {(text || component) && <Flex>{text || component}</Flex>}
          <Flex direction="row" justify="space-between">
            <Button onClick={this.handleApprove} size="lg">
              <Text uppercase>{labelApprove || resources.labelApprove}</Text>
            </Button>
            {type === EDialogType.CONFIRM && (
              <Button variant="secondary" onClick={this.handleCancel} size="lg">
                <Text uppercase>{labelCancel || resources.labelCancel}</Text>
              </Button>
            )}
          </Flex>
        </Flex>
      </StyledModal>
    );
  }
}

export const Dialog = inDialogModal(DialogComponent);
